export default __webpack_public_path__ + "static/media/regulatory--no-cargo-loading--g1.1b0eeb2b.png";